<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheHeader />
    <TheSidebar />

    <div
      class="c-wrapper"
      :class="{ 'sidebar-open': $store.state.sidebarShow }"
    >
      
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter />
      </div>
    </div>

    <CenterLoading />
    <DialogMessage />
    <SignIn />
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from '../TheFooter'
import { mapActions } from "vuex";

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
  },
  mounted() {
    this.loadUserProfile();
  },
  methods: {
    ...mapActions("user", ["getProfile"]),
    async loadUserProfile() {
      try {
        await this.getProfile(); 
      } catch (err) {
        console.error("Load profile error:", err);
      }
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.c-wrapper {
  transition: margin-left 0.3s ease;
  /* ค่าเริ่มต้นสำหรับมือถือ: ไม่ต้องมี margin ซ้าย */
  margin-left: 0 !important; 
  width: 100%;
}

.c-body {
  padding-top: 66px; 
  min-height: 100vh;
}

/* 🔥🔥🔥 จุดที่แก้ไข: ใช้ Media Query บังคับเฉพาะหน้าจอใหญ่ (Desktop) 🔥🔥🔥 */
@media (min-width: 992px) {
  /* เมื่อหน้าจอกว้างกว่า 992px (Desktop/Tablet แนวนอน) ถึงจะขยับ Margin */
  .sidebar-open {
    margin-left: 250px !important; /* ความกว้าง Sidebar */
  }
  
  .sidebar-minimized {
    margin-left: 80px !important;
  }
}
</style>